<template>
  <div class="accordion w-100">
    <div class="accordion-header form-group" style="width: fit-content" v-on:click="toggleAccordion">
      {{ title }}
      <i class="fa-light fa-chevron-down" :style="{color: chevronColor}"
         v-if="isOpen">{{ chevronOpen }}</i>
      <i class="fa-light fa-chevron-down" :style="{color: chevronColor}"
         v-if="!isOpen">{{ chevronClose }}</i>
    </div>
    <transition name="accordion-v2"
      v-on:before-enter="beforeEnter" v-on:enter="enter"
      v-on:before-leave="beforeLeave" v-on:leave="leave">
      <div class="accordion-body" v-show="isOpen" style="height: auto !important">
        <div class="accordion-body-inner">
          <slot></slot>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'FormAccordionV2',
  props: {
    id: {
      type: String,
      default: 'default'
    },
    title: {
      type: String,
      default: ''
    },
    open: {
      type: Boolean,
      default: false
    },
    'chevron-open': {
      type: String,
      default: 'chevron_down'
    },
    'chevron-close': {
      type: String,
      default: 'chevron_right'
    },
    'chevron-color': {
      type: String,
      default: '#2E4057'
    }
  },
  watch: {
    open: function (newVal, oldVal) {
      this.isOpen = newVal
    }
  },
  data: function () {
    return {
      isOpen: false
    }
  },
  created () {
    this.isOpen = this.open
  },
  mounted () {
  },
  methods: {
    toggleAccordion () {
      this.isOpen = !this.isOpen
    },
    beforeEnter: function (el) {
      el.style.height = '0'
    },
    enter: function (el) {
      el.style.height = 'auto'
    },
    beforeLeave: function (el) {
      el.style.height = 'auto'
    },
    leave: function (el) {
      el.style.height = '0'
    }
  }
}
</script>

<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.accordion .accordion-body {
  overflow: hidden;
  transition: 150ms ease-out;
}

.accordion .accordion-body-inner {
  overflow-wrap: break-word;
}

.accordion-header:hover {
  cursor: pointer;
  text-decoration: underline;
}
</style>
